import { TvvBus } from "@/entities/tvv/domain/tvv-bestelde-route.ts";
import { Icon } from "@/shared/components";

type AfgeschaaldeBussenProps = {
    bussen: TvvBus[];
};

export function AfgeschaaldeBussen({ bussen }: AfgeschaaldeBussenProps) {
    return (
        bussen.length > 0 && (
            <span className="text-s text-content-subtle flex flex-row flex-wrap items-center gap-2 text-wrap">
                Afgeschaald:
                {bussen.map((bus) => (
                    <span key={bus.id} className="flex flex-row items-center gap-0.5" data-testid="afgeschaalde-bus">
                        <Icon name="bus" />
                        {TvvBus.getShortLabel(bus)}
                    </span>
                ))}
            </span>
        )
    );
}
